import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { LeadsColumnsConfigDto } from "../../types";
import { leadsSearchQueryKeys } from "../key-factory/factory";

export const useColumnsConfigQuery = <T = LeadsColumnsConfigDto>(select?: (data: LeadsColumnsConfigDto) => T) => {
    return useQuery<LeadsColumnsConfigDto, unknown, T>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: leadsSearchQueryKeys.columnConfig(),
        placeholderData: keepPreviousData,
        select,
        queryFn({ signal }) {
            return salesApiService.leadsSearch.fetchColumnConfig({ cancellation: signal });
        },
    });
};
